{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Zobraziť všetky možnosti",
  "Spoiler_Reveal_Tooltip": "Kliknutím odhalíte",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweetujte to",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Položka je zbalená",
  "Spoiler_Reveal_Video_CTA": "Odhaliť video",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Rozbaliť obrázok",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Zobraziť všetky výsledky",
  "Spoiler_Reveal_Image_Placeholder": "Tento obrázok obsahuje spojler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Posuvník vyhľadávania",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Môžete hlasovať za viac ako jednu odpoveď.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Zobraziť ďalšie ovládacie prvky zvuku",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Zatvoriť",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Načítanie {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "Prečítať si viac",
  "Spoiler_Insert_Tooltip": "Spojler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Hlasitosť",
  "Spoiler_Reveal_Gallery_Placeholder": "Táto galéria obsahuje spojler",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Rezervovať teraz",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Zrušiť stlmenie",
  "Spoiler_Reveal_Gallery_CTA": "Odhaliť galériu",
  "Poll_Viewer_ShowLess_CTA": "Ukázať menej",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Stlmiť",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+ {{anonNumber}} anonymných",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Sledovať",
  "VerticalEmbed_Products_Button": "Kúpiť teraz",
  "Poll_Viewer_Toast_Error_ServerDown": "Nepodarilo sa pripojiť k serveru. Skúste to znova neskôr.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "Za túto odpoveď hlasoval {{count}}",
  "Poll_Viewer_VoteCount": "Počet hlasov: {{number}}",
  "VerticalEmbed_Events_Button": "Zaregistrujte sa teraz",
  "Spoiler_Reveal_Image_CTA": "Odhaliť obrázok",
  "Poll_Viewer_Toast_Error_Connection": "Žiadny internet. Skontrolujte pripojenie.",
  "Poll_Viewer_Visibility_Owner_Footer": "Výsledky vidíte iba vy.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "Za túto odpoveď hlasovalo {{count}}",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Položka je rozbalená",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "Toto video obsahuje spojler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Zobraziť celý príspevok",
  "UploadFile_Viewer_Download": "Stiahnuť {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}h",
  "VerticalEmbed_Units_Minute": "{{minutes}}min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
